import { useEffect, useState } from 'react'

export const useFetch = <T> (fetchFn: () => Promise<T>) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [data, setData] = useState<T>()

  //todo use Callback????
  const fetchData = async () => {
    setError('')
    setLoading(true)
    try {
      const result = await fetchFn()
      setData(result)
    } catch (error: any) {
      setError(error.toString())
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { data, loading, error, fetchData }
}
